(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('PaymentSlipConfirmationService', PaymentSlipConfirmationService)

    /** @ngInject */
    function PaymentSlipConfirmationService(HttpService) {
        const PaymentSlipConfirmationService = {
            getByParameters,
            get,
            save,
            delete: deleteRemittance
        }

        return PaymentSlipConfirmationService;

        function getByParameters(params) {
            return HttpService.get('/payment/remittances/confirmation/by-parameters', {
                params
            });
        }

        function get(paymentConfirmationRemittanceId) {
            return HttpService.get(`/payment/remittances/confirmation/${paymentConfirmationRemittanceId}`);
        }

        function save(paymentConfirmationRemittanceData) {
            return HttpService.post('/payment/remittances/confirmation', paymentConfirmationRemittanceData);
        }

        function deleteRemittance(paymentRemittanceId) {
            return HttpService.delete(`/payment/remittances/confirmation/${paymentRemittanceId}`);
        }
    }
}());